import { render, staticRenderFns } from "./WorkerTaskSelector.vue?vue&type=template&id=54bff270&"
import script from "./WorkerTaskSelector.vue?vue&type=script&lang=js&"
export * from "./WorkerTaskSelector.vue?vue&type=script&lang=js&"
import style0 from "./WorkerTaskSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports